<template>
    <b-row>
        <b-col cols="12" md="5" v-if="!disableClient">
            <app-autocomplete
                placeholder="Clientes"
                v-model="selectedClient"
                :items="clients"
                @change="onClientChange"
            ></app-autocomplete>
        </b-col>
        <b-col cols="12" md="3">
            <app-form-select-input
                placeholder="Sedes"
                :options="venues"
                v-model="filters.venueId"
                @change="onVenueChange"
            ></app-form-select-input>
        </b-col>
        <b-col cols="12" md="2">
            <app-form-select-input
                placeholder="Estructuras"
                :options="structures"
                v-model="filters.structureId"
            ></app-form-select-input>
        </b-col>
        <b-col>
            <b-btn variant="primary" @click="onFilter"><i class="fa fa-filter"></i></b-btn>
            <b-btn variant="secondary" @click="onClearFilters"><i class="fa fa-times"></i></b-btn>
        </b-col>
    </b-row>
</template>
<script>
import Autocomplete from '@components/UI/Controls/AutocompleteV2/Autocomplete';
import { mapGetters } from 'vuex';
import venuesRepository from '@repositories/venues.repository';
import structuresRepository from '@repositories/structures.repository';
export default {
    components: {
        appAutocomplete: Autocomplete
    },
    data: () => ({
        filters: {
            clientId: '',
            venueId: '',
            structureId: ''
        },
        venues: [],
        structures: [],
        selectedClient: ''
    }),
    computed: {
        ...mapGetters(['clients']),
        disableClient() {
            return !!this.user.profile.client_side  || this.user.profile.slug === 'vigilante';
        }
    },
    methods: {
        async loadVenues(client) {
            const vr = {...venuesRepository};
            try {
                const {data} = await vr.get({client});
                this.venues = data;
                if(data.length === 1) {
                    // this.filters.venueId = data[0].id;
                    this.loadStructures(data[0].id);
                }
            }catch(err) {
                this.handleErrors(err);
            }
        },
        async loadStructures(venue) {
            const sr = {...structuresRepository};
            try {
                const {data} = await sr.get({venue});
                this.structures = data;
            }catch(err) {
                this.handleErrors(err);
            }
        },
        onClientChange(client) {
            this.filters.clientId = !!client? client.id: '';
            this.venues = [];
            this.structures = [];
            !!client && this.loadVenues(client.id);
        },
        onVenueChange(venue) {
            this.structures = [];
            this.loadStructures(venue);
        },
        onFilter() {
            this.$emit('filter', this.filters);
        },
        onClearFilters() {
            this.selectedClient = '';
            Object.keys(this.filters).map(key => this.filters[key] = '');
            this.$emit('filter', null);
        }
    },
    mounted() {
        this.load('clients');
        if(this.user.profile.client_side || this.user.profile.slug === 'vigilante') {
            this.filters.clientId = this.client.id;
            this.loadVenues(this.client.id);
        }
    }
}
</script>